export default __webpack_public_path__ + "static/media/threeDSecureLogo.91160fe3.svg";